/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClassificationType } from '../../models/classification-type';
import { DemoAccountDataVersionCto } from '../../models/demo-account-data-version-cto';

export interface GetDemoAccountDataHistoryAsync$Json$Params {
  demoDataType: ClassificationType;
}

export function getDemoAccountDataHistoryAsync$Json(http: HttpClient, rootUrl: string, params: GetDemoAccountDataHistoryAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DemoAccountDataVersionCto>>> {
  const rb = new RequestBuilder(rootUrl, getDemoAccountDataHistoryAsync$Json.PATH, 'get');
  if (params) {
    rb.path('demoDataType', params.demoDataType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DemoAccountDataVersionCto>>;
    })
  );
}

getDemoAccountDataHistoryAsync$Json.PATH = '/demo-account-data/{demoDataType}/history';
